import getDocument from './getDocument';
export const getExtensionAppId = () => {
  const document = getDocument();
  const idCollection = /^\/app\/\d+\/(\d+)(?:\/|$)/.exec(document.location.pathname);
  if (Array.isArray(idCollection) && idCollection.length > 1) {
    return Number(idCollection[1]);
  }
};